(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Grid thumbnails click handler
  document.addEventListener('DOMContentLoaded', function() {
    // Desktop thumbnails (vertical, in wrapper)
    const thumbnailContainers = document.querySelectorAll('.media-gallery__grid-thumbnails');

    thumbnailContainers.forEach(container => {
      const thumbnails = container.querySelectorAll('.media-gallery__grid-thumbnail');
      const wrapper = container.closest('.media-gallery__grid-with-thumbnails');
      const grid = wrapper ? wrapper.querySelector('.media-gallery__grid') : null;

      if (!grid) return;

      const gridItems = grid.querySelectorAll('li');

      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          // Update active state for both desktop and mobile
          document.querySelectorAll('.media-gallery__grid-thumbnail').forEach(t => t.classList.remove('media-gallery__grid-thumbnail--active'));
          document.querySelectorAll(`.media-gallery__grid-thumbnail[data-media-index="${index}"]`).forEach(t => t.classList.add('media-gallery__grid-thumbnail--active'));

          // Scroll to corresponding grid item
          const targetItem = gridItems[index];
          if (targetItem) {
            targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      // Update active thumbnail on scroll
      const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Array.from(gridItems).indexOf(entry.target);
            if (index !== -1) {
              document.querySelectorAll('.media-gallery__grid-thumbnail').forEach(t => t.classList.remove('media-gallery__grid-thumbnail--active'));
              document.querySelectorAll(`.media-gallery__grid-thumbnail[data-media-index="${index}"]`).forEach(t => t.classList.add('media-gallery__grid-thumbnail--active'));
            }
          }
        });
      }, observerOptions);

      gridItems.forEach(item => observer.observe(item));
    });

    // Mobile thumbnails (horizontal, separate container)
    const mobileThumbnailContainers = document.querySelectorAll('.media-gallery__grid-thumbnails-mobile');

    mobileThumbnailContainers.forEach(container => {
      const thumbnails = container.querySelectorAll('.media-gallery__grid-thumbnail');
      const mediaGallery = container.closest('media-gallery');
      const slideshow = mediaGallery ? mediaGallery.querySelector('slideshow-component') : null;

      if (!slideshow) return;

      // Get slides from slideshow
      const getSlides = () => Array.from(slideshow.querySelectorAll('slideshow-slide'));

      // Find the scroller element
      const scroller = slideshow.querySelector('.slideshow__scroller') || slideshow.querySelector('[ref="scroller"]');

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const index = parseInt(thumbnail.getAttribute('data-media-index'), 10);
          const slides = getSlides();
          const targetSlide = slides[index];

          if (targetSlide && scroller) {
            // Update active state
            document.querySelectorAll('.media-gallery__grid-thumbnail').forEach(t => t.classList.remove('media-gallery__grid-thumbnail--active'));
            document.querySelectorAll(`.media-gallery__grid-thumbnail[data-media-index="${index}"]`).forEach(t => t.classList.add('media-gallery__grid-thumbnail--active'));

            // Scroll horizontally within the scroller without moving the page
            const slideLeft = targetSlide.offsetLeft;
            scroller.scrollTo({ left: slideLeft, behavior: 'smooth' });
          }
        });
      });

      // Listen for slideshow changes to update active thumbnail
      slideshow.addEventListener('slideshow:select', (event) => {
        const slideIndex = event.detail?.index;
        if (slideIndex !== undefined) {
          document.querySelectorAll('.media-gallery__grid-thumbnail').forEach(t => t.classList.remove('media-gallery__grid-thumbnail--active'));
          document.querySelectorAll(`.media-gallery__grid-thumbnail[data-media-index="${slideIndex}"]`).forEach(t => t.classList.add('media-gallery__grid-thumbnail--active'));
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
